import { render, staticRenderFns } from "./qqconfiguration.vue?vue&type=template&id=08256e72&scoped=true"
import script from "./qqconfiguration.vue?vue&type=script&lang=js"
export * from "./qqconfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08256e72",
  null
  
)

export default component.exports